// extracted by mini-css-extract-plugin
export default {"promo":"promo--Cf6yk"};